import { setStyle } from 'core/utils/lemonade';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Switch from 'ui/atoms/Switch/Switch';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';

import useDialogActivityPreview from './useDialogActivityPreview';

const DialogActivityPreview = ({ open, activity, onClose, title, isAutoevaluative, onAddQuestion, questionQuid, selected, disabled }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const { Question, showCorrectAnswer, resetQuestion, t, background } = useDialogActivityPreview({
    activity,
  });

  function onChangeShowAnswer() {
    if (showAnswer) {
      resetQuestion();
    } else {
      showCorrectAnswer(true);
    }
    setShowAnswer((prev) => !prev);
  }

  return (
    <Dialog
      title={title}
      isOpen={open}
      className={'dialog-activity-preview'}
      onClose={onClose}
      size="l"
      buttonTextSuccess={selected ? t('actions:Delete') : t('actions:Select')}
      onSuccess={() => onAddQuestion(questionQuid)}
      disabledSuccess={disabled}
    >
      <div className="dialog-activity-preview__content">
        <div style={setStyle(background)}>
          <Question />
        </div>
        {isAutoevaluative && (
          <div className="dialog-activity-preview__controls">
            <Switch checked={showAnswer} onChange={onChangeShowAnswer} label={t('actions:Show solution')} />
          </div>
        )}
      </div>
    </Dialog>
  );
};

DialogActivityPreview.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

DialogActivityPreview.defaultProps = {
  onClose: function () {},
  open: false,
};

export default DialogActivityPreview;
